import { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useAuthStore } from '@/stores/authStore';
import { listPendingCardPaymentOrders } from '@/api/orders';

export function PendingPaymentBanner() {
  const user = useAuthStore((s) => s.user);
  const [count, setCount] = useState(0);
  const [dismissed, setDismissed] = useState(false);

  useEffect(() => {
    if (!user?.id) {
      setCount(0);
      return;
    }
    void listPendingCardPaymentOrders(user.id).then((orders) => setCount(orders.length));
  }, [user?.id]);

  if (!user || dismissed || count === 0) return null;

  return (
    <div className="mb-3 mt-3 flex flex-wrap items-center justify-between gap-3 rounded-lg border border-amber-300 bg-amber-50 px-4 py-3 text-sm text-amber-950 dark:border-amber-700 dark:bg-amber-950/40 dark:text-amber-100">
      <p>
        You have {count} order{count === 1 ? '' : 's'} awaiting payment.{' '}
        <Link to="/orders" className="font-semibold underline">
          Complete payment
        </Link>
      </p>
      <button
        type="button"
        className="text-xs font-semibold text-amber-800 underline dark:text-amber-200"
        onClick={() => setDismissed(true)}
      >
        Dismiss
      </button>
    </div>
  );
}
